import React, { useState } from "react";
import { Dialog, IconButton, Box, useTheme, Tooltip } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CloseIcon from "@mui/icons-material/Close";
import { VideoPlayer } from "./HelpDialogItems"; // Assuming this import path is correct
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import YouTubeIcon from "@mui/icons-material/YouTube";
/**
 * VideoGuideDialog - A reusable component that displays a play button which opens a video dialog
 *
 * @param {Object} props
 * @param {string} props.videoUrl - URL of the video to play
 * @param {string} props.posterUrl - URL of the poster/thumbnail image
 * @param {string} props.iconSize - Size of the play icon (default: "4rem")
 * @param {Object} props.buttonStyle - Additional styles for the play button
 * @param {boolean} props.autoPlay - Whether to autoplay the video when dialog opens (default: true)
 * @param {string} props.tooltip - Tooltip text for the button
 * @param {boolean} props.controls - Whether to show video controls
 * @param {boolean} props.compact - Whether to show compact YouTube icon button instead of video player
 */
const VideoGuideDialog = ({
  videoUrl,
  posterUrl,
  iconSize = "1rem",
  buttonStyle = {},
  autoPlay = true,
  tooltip,
  controls,
  compact = false,
}) => {
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const theme = useTheme();

  const handleOpenVideo = () => {
    setVideoDialogOpen(true);
  };

  return (
    <>
      {compact ? (
        <Tooltip title={tooltip || "Play Video"}>
          <IconButton
            onClick={handleOpenVideo}
            sx={{
              ...buttonStyle,
              color: theme.palette?.primary?.main || "#1976d2",
            }}
          >
            <YouTubeIcon sx={{ fontSize: iconSize, color: "#969696" }} />
          </IconButton>
        </Tooltip>
      ) : (
        <Box onClick={handleOpenVideo}>
          <VideoPlayer
            videoUrl={videoUrl}
            poster={posterUrl}
            disableClick={true}
          />
        </Box>
      )}

      {/* Video Dialog */}
      <Dialog
        open={videoDialogOpen}
        onClose={() => setVideoDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { backgroundColor: "transparent" },
        }}
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            aria-label="close"
            onClick={() => setVideoDialogOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "white",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1,
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.7)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
          <VideoPlayer
            videoUrl={videoUrl}
            poster={posterUrl}
            autoPlay={autoPlay}
            controls={controls}
          />
        </Box>
      </Dialog>
    </>
  );
};

export default VideoGuideDialog;
